import { render, staticRenderFns } from "./message-content-contact-request.vue?vue&type=template&id=3d8a2f16&scoped=true&"
import script from "./message-content-contact-request.vue?vue&type=script&lang=js&"
export * from "./message-content-contact-request.vue?vue&type=script&lang=js&"
import style0 from "./message-content-contact-request.vue?vue&type=style&index=0&id=3d8a2f16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a2f16",
  null
  
)

export default component.exports